var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"orderTest-container"},[_c('banner'),_c('instance'),_c('architecture'),_c('cloudService'),_c('OSconstitute')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }